import useNotification from "./useNotification";

const getCurrentUser = () =>
  JSON.parse(localStorage.getItem("user")) ||
  JSON.parse(sessionStorage.getItem("user"));

const getOwnerIdFromArticle = (article) =>
  article?.utilisateur?._id ||
  article?.idUtilisateur?._id ||
  article?.idUtilisateur;

export default function useNotify() {
  const { createNotification } = useNotification();

  const notify = async ({
    userId,
    articleId,
    type,
    message,
    archive = 2,
    vu = 2,
  }) => {
    if (!userId || !type || !message) return null;

    return createNotification({
      id_utilisateur: userId,
      id_article: articleId,
      type,
      message,
      archive,
      vu,
    });
  };

  const notifyArticlePublished = async (createdArticle) => {
    const currentUser = getCurrentUser();
    if (!currentUser?._id || !createdArticle?._id) return null;

    return notify({
      userId: currentUser._id,
      articleId: createdArticle._id,
      type: 3,
      message: `Votre annonce "${createdArticle.titre}" a bien été publiée.`,
    });
  };

  const notifyArticleLiked = async (article) => {
    const currentUser = getCurrentUser();
    const ownerId = getOwnerIdFromArticle(article);
    if (!currentUser?._id || !ownerId || ownerId === currentUser._id) return null;

    const fullName =
      `${currentUser.nom ?? ""} ${currentUser.prenom ?? ""}`.trim() || "Un utilisateur";

    return notify({
      userId: ownerId,
      articleId: article?._id,
      type: 3,
      message: `${fullName} a aimé votre annonce : ${article?.titre}`,
    });
  };

  const notifyArticleMessage = async (article, texte) => {
    const currentUser = getCurrentUser();
    const ownerId = getOwnerIdFromArticle(article);
    if (!currentUser?._id || !ownerId || ownerId === currentUser._id) return null;

    const fullName =
      `${currentUser.nom ?? ""} ${currentUser.prenom ?? ""}`.trim() || "Un utilisateur";

    return notify({
      userId: ownerId,
      articleId: article?._id,
      type: 1,
      message: `Vous avez reçu un message de ${fullName} pour l'annonce "${article?.titre}". Message: ${texte}`,
    });
  };

  return {
    notify,
    notifyArticlePublished,
    notifyArticleLiked,
    notifyArticleMessage,
  };
}
